import type { ReactNode } from 'react';
import { Spinner } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import {
  ProfileCard,
  type ProfileCardContract,
} from '../../../../app/_shared/educationProfile';
import '../../../../app/_shared/educationProfile/EducationProfile.scss';
import './PublicProfilePage.scss';

type PublicProfileViewProps = {
  isLoading: boolean;
  isMissing: boolean;
  card: ProfileCardContract;
  title?: string;
  publicPath?: string;
  children: ReactNode;
};

export function PublicProfileView({
  isLoading,
  isMissing,
  card,
  title,
  publicPath,
  children,
}: PublicProfileViewProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="education-profile-layout">
        <div className="education-profile-page">
          <Spinner />
        </div>
      </div>
    );
  }

  if (isMissing || card.surface !== 'read' || !card.identity.displayName) {
    return (
      <div className="education-profile-layout">
        <div className="education-profile-page">
          <p className="description">{t('public-profile.not_found')}</p>
        </div>
      </div>
    );
  }

  const address = publicPath
    ? `${window.location.origin}${publicPath}`
    : null;

  return (
    <div className="education-profile-layout">
      <aside className="education-profile-layout__summary">
        <ProfileCard contract={card} />
      </aside>

      <div className="education-profile-layout__main">
        <div className="education-profile-page">
          <header className="education-profile-page__header">
            <div className="education-profile-page__intro">
              {title ? (
                <div className="education-profile-page__heading">
                  <h1>{title}</h1>
                </div>
              ) : null}
            </div>
          </header>

          <div className="education-profile-page__divider" />

          {address ? (
            <div className="profile-read-address">
              <span className="profile-read-value__label">
                {t('public-profile.url_label')}
              </span>
              <p className="profile-read-value__text">{address}</p>
            </div>
          ) : null}

          <div className="education-profile-form">{children}</div>
        </div>
      </div>
    </div>
  );
}
